import { Button } from "@mui/material";
import React, { useState } from "react";
import { IBrand } from "../../../brand/team/data/type";
import config from "../../../../config";
import { IconAttachment } from "../../../../utils/icons";
import { PanelFooter } from "./PanelFooter";

interface Props {
  brand: IBrand;
  openSettings: () => void;
  s3id?: number | null;
}

export function EmbedCodePanel({ brand, s3id, openSettings }: Props) {
  const [isCopied, setIsCopied] = useState<boolean>();

  const formatEmbedCode = () =>
    `<script class="tdc2-single" bid="${brand.id}" b="${brand.slug}" fid="${s3id}" type="text/javascript" src="${config.EMBED_HOST}/assets/js/e2s.js?source=embed"></script>`;

  const onCopyBtnClick = () => {
    navigator.clipboard.writeText(formatEmbedCode());
    setIsCopied(true);
    setTimeout(setIsCopied, 2000);
  };

  return (
    <div className="flex flex-col gap-2 justify-between h-full">
      <div className="py-6 flex flex-col w-full gap-4 flex-1 min-h-0 overflow-y-auto">
        <div className="p-4 bg-surface-2 rounded-md">
          <p
            style={{
              wordWrap: "break-word",
              fontFamily: "CircularStd",
            }}
          >
            {formatEmbedCode()}
          </p>
        </div>
      </div>
      <PanelFooter>
        <Button
          variant="contained"
          color="primary"
          onClick={onCopyBtnClick}
          endIcon={<IconAttachment stroke="#fff" />}
          sx={{ textTransform: "capitalize" }}
        >
          {isCopied ? "Copied!" : "Copy Embed Code"}
        </Button>
      </PanelFooter>
    </div>
  );
}
